import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import SolutionImportModal from "../Solutions/SolutionImportModal";

export default function SolutionDeployRouteModal() {
  const { clientSolutionUuid } = useParams<{ clientSolutionUuid: string }>();
  const navigate = useNavigate();
  const closeModal = () => navigate("/library/solutions/purchased");

  if (!clientSolutionUuid) return null;

  return (
    <Modal
      show
      onHide={closeModal}
      dialogClassName="modal-xxl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Deploy Solution</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="bg-solution">
          <SolutionImportModal
            solutionClientUuid={clientSolutionUuid}
            setShow={(show) => {
              if (!show) closeModal();
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}
